import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  /** Upward travel in pixels. */
  y?: number;
  /** Small horizontal travel for editorial photo columns. */
  x?: number;
  /** Stagger delay in seconds. */
  delay?: number;
  /** Render as a different element, e.g. "li" inside a list. */
  as?: 'div' | 'li';
};
const easing = [0.22, 0.61, 0.36, 1] as const;

/**
 * Single on-scroll entrance used site-wide: fade in while rising ~24px, once.
 * With prefers-reduced-motion the content renders immediately.
 */
export function Reveal({
  children,
  className = '',
  y = 24,
  x = 0,
  delay = 0,
  as = 'div'
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return as === 'li' ? <li className={className} data-id="element-365" data-mp="6drs0aofv04z">{children}</li> : <div className={className} data-id="element-366" data-mp="6gnso6ro82x4">{children}</div>;
  }
  const MotionTag = as === 'li' ? motion.li : motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y,
    x
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.55,
    delay,
    ease: easing
  }} data-id="element-367" data-mp="uz0pyjb0qusk">
      {children}
    </MotionTag>;
}

/** Stagger step used for grouped cards and photo grids. */
export const stagger = (index: number, step = 0.09) => index * step;